import { __awaiter, __generator } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import useLanguage from '../../hooks/useLangugle/index.js';
import TiSpin from '../../TiSpin/index.js';
import './index.less.js';

var Bottom = function Bottom(props) {
  var more = props.more,
    infinite = props.infinite,
    loadMore = props.loadMore;
  var ListLocale = useLanguage('List');
  var _a = useInView({
      threshold: 0.1
    }),
    ref = _a.ref,
    inView = _a.inView;
  var _b = useState(false),
    loading = _b[0],
    setLoading = _b[1];
  var onLoadNextPage = function onLoadNextPage() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!inView || !more || !infinite) {
              return [2 /*return*/];
            }
            setLoading(true);
            return [4 /*yield*/, loadMore()];
          case 1:
            _a.sent();
            setLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };
  useEffect(function () {
    onLoadNextPage();
  }, [inView]);
  var renderNode = function renderNode() {
    if (!infinite) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    if (loading) {
      return /*#__PURE__*/React.createElement(TiSpin, {
        size: "small",
        presetStyle: "dot"
      });
    }
    if (!more) {
      return ListLocale.noMoreData;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "ti-list-bottom"
  }, renderNode());
};

export { Bottom as default };
